export default __webpack_public_path__ + "static/media/video.b4199639.svg";